export class UsuarioUpsert
{    
    fechaHora:Date;
    ipOrigen :string;
    objectId2 :string;
}
